import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchCounter = async () => {
  const { data } = await api.get("/counter");
  return data;
};

export const createSubmission = async (payload) => {
  const { data } = await api.post("/submissions", payload);
  return data;
};
